// extracted by mini-css-extract-plugin
export var body = "styles-module--body--5fd8f";
export var card = "styles-module--card--03c76";
export var container = "styles-module--container--2b8c9";
export var containerRelative = "styles-module--containerRelative--9442a";
export var containerVisible = "styles-module--containerVisible--38cdd";
export var heading = "styles-module--heading--94582";
export var text = "styles-module--text--88b41";